<template>
  <Modal title="监课记录" v-model="visible" width="535">
    <Table class="compact" size="small" :columns="recordColumn" :data="recordList"></Table>
    <div slot="footer"></div>
  </Modal>
</template>
<script>
  export default {
    name: 'MonitorLessonRecordListModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let $moment = this.$moment 
      return {
        visible: this.value,
        recordList: [],
        recordColumn: [
          {
            title: '记录人',
            width: 121,
            key: 'adminNickname'
          },
          {
            title: '记录时间',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let recordingTime = params.row.recordingTime
              return h('span', $moment(recordingTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '记录内容',
            width: 230,
            key: 'recordingContent'
          },
        ]
      }
    },
    methods: {
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/monitorLessonRecord/queryByOpenId', { params: {openId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            return
          }
          self.visible = true
          self.recordList = res.data
        })
      },
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }  
</script>



// WEBPACK FOOTER //
// MonitorLessonRecordListModal.vue?08753ca1